module.exports = __webpack_public_path__ + "img/page.2b092dc6.png";